import settingsService from "@/api/settingsService";
import { MESSAGES, VEHICLE_SPEED_LIMIT } from "@/utils/constants";
import { notify, notifyError } from "@/utils/notification-helper";

const state = {}

const getters = {
    getVehicleTypes: (state, getters, rootState, rootGetters) => rootGetters.getVehicleTypes,
    getLoaderStatus: (state, getters, rootState, rootGetters) => rootGetters.getLoaderStatus,
    getSpeedLimit: (state, getters, rootState, rootGetters) => {
        console.log('#Speed ', rootGetters.getSpeedLimit)
        return rootGetters.getSpeedLimit ? rootGetters.getSpeedLimit.map((sl, index) => ({ ...sl, serialNo: index + 1 })) : [];
    },
    getVehicleSafeSpeedLimitColor: (state, getters, rootState, rootGetters) => rootGetters.getVehicleSpeedLimitColors.find((slc) => slc.key == VEHICLE_SPEED_LIMIT.SAFE_SPEED),
    getVehicleHighSpeedLimitColor: (state, getters, rootState, rootGetters) => rootGetters.getVehicleSpeedLimitColors.find((slc) => slc.key == VEHICLE_SPEED_LIMIT.HIGH_SPEED),
    getVehicleModerateSpeedLimitColor: (state, getters, rootState, rootGetters) => rootGetters.getVehicleSpeedLimitColors.find((slc) => slc.key == VEHICLE_SPEED_LIMIT.MODERATE_SPEED),
};

const actions = {
    async fetchSpeedLimit({ commit, getters }) {
        commit('setLoader', true, { root: true });
        const response = await settingsService.getSpeedlimit();
        commit('setLoader', false, { root: true });
        const result = response.data.result.map((vl) => {
            const vehicleType = getters.getVehicleTypes.find((vt) => vt.id === vl.vehicleTypeId)
            return {
                ...vl,
                vehicleType: vehicleType ? vehicleType : {},
            }
        });
        commit('setSpeedLimit', result, { root: true });
    },
    async addSpeedLimit({ commit }, body) {
        const response = await settingsService.addSpeedLimit(body);
        if (response.data.status)
            commit('addSpeedLimit', response.data.result, { root: true });
        else {
            if (response.data.message.includes('existing Speed Limit')) {
                commit('addSpeedLimit', response.data.result, { root: true });
                notify(MESSAGES.RECORD_CREATE_SUCCESS);
            } else {
                notifyError(response.data.message);
            }
        }
    },
    async updateSpeedLimit({ commit, getters }, body) {
        const { data } = await settingsService.updateSpeedLimit(body);
        if (data.status) {
            const vehicleType = getters.getVehicleTypes.find((vt) => vt.id === data.vehicleTypeId);
            data.vehicleType = vehicleType ? vehicleType : {},
                commit('updateSpeedLimit', data.result, { root: true });
        }
    },
    async removeSpeedLimit({ commit }, id) {
        await settingsService.removeSpeedLimit(id);
        commit('removeSpeedLimit', id, { root: true });
    },
    async getVehicleSpeedLimitColors({ commit }) {
        const response = await settingsService.getVehicleSpeedLimitColors();
        if (response.data.status)
            commit('setVehicleSpeedLimitColors', response.data.result, { root: true });
    },
    async changeSpeedLimitColor({ commit, }, data) {
        const body = {
            type: "SpeedLimitColor",
            key: data.key,
            value: data.value
        }
        const response = await settingsService.changeSpeedLimitColor(body);
        if (response.data.status) {
            commit('updateVehicleSpeedLimitColors', response.data.result, { root: true });
            return true;
        } else {
            notifyError(response.data.message);
            return false;
        }
    },
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}